var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLevel4 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 15,
    viewBox: "0 0 42 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Levels"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.4999 7.04842L26.496 0.0429688H19.8096L24.8134 7.04842L19.8096 14.0539H26.496L31.4999 7.04842Z",
    fill: "#00AC2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.1903 7.04842L36.1864 0.0429688H29.5L34.5039 7.04842L29.5 14.0539H36.1864L41.1903 7.04842Z",
    fill: "#00AC2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.2937 7.04842L17.2899 0.0429688H10.708L15.7119 7.04842L10.708 14.0539H17.2899L22.2937 7.04842Z",
    fill: "#00AC2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.1923 7.04842L8.18845 0.0429688H0V14.0539H8.18845L13.1923 7.04842Z",
    fill: "#00AC2E"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLevel4);
export default ForwardRef;